import { useStore } from '@/hooks/useStore';
import { OptionEnduser } from '@/types/option';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { OptionComp } from '../OptionComp';
import { formatCurrency } from '@/utils/formatNumber';
import { useTranslation } from 'react-i18next';

export default observer(function OptionList() {
    const { t } = useTranslation();

    // state
    const [options, setOptions] = useState<OptionEnduser>();

    // store
    const {
        optionStore: { optionsForOrder }
    } = useStore();

    // lifecycle
    useEffect(() => {
        if (optionsForOrder && Object.keys(optionsForOrder).length > 0) {
            setOptions(optionsForOrder);
        }
    }, [optionsForOrder]);

    return options ?
        (
            <>
                <OptionComp
                    option={{
                        title: t('price_list.title_section.option'),
                        data: [
                            {
                                fieldName: '',
                                value: t('price_list.weekly_rates'),
                                valueClass: 'bg-subtle font-medium'
                            },
                            ...options?.option.map(option => ({ fieldName: option.name, value: `${formatCurrency(option.price)}${t('currency.currency_unit')}` }))
                        ],
                        specialNote: [t('sentences.price_contain_tax')],
                        textDecoration: t('price_list.text_decoration.option')
                    }}
                />
                <OptionComp
                    option={{
                        title: t('price_list.title_section.insurance'),
                        data: [
                            {
                                fieldName: '',
                                value: t('price_list.weekly_rates'),
                                valueClass: 'bg-subtle font-medium'
                            },
                            ...options?.compensation.map(option => ({ fieldName: option.name, value: `${formatCurrency(option.price)}${t('currency.currency_unit')}` }))
                        ],
                        specialNote: [t('sentences.insurance_note_1'), t('sentences.insurance_note_2'), t('sentences.insurance_note_3'), t('sentences.insurance_note_4'), t('sentences.price_contain_tax')],
                        descriptionList: [t('sentences.insurance_des_1'), t('sentences.insurance_des_2')],
                        textDecoration: t('price_list.text_decoration.insurance')
                    }}
                />
            </>
        ) :
        <></>;
});
